if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* Gift prompt (added Oct 2026).
   Givy only allows one-time gifts, so its Send as Gift button is disabled while
   Subscribe & Save is selected in the Recharge widget. This shows a one-line prompt
   under the button in that state. To change the wording, edit GIFT_PROMPT_TEXT.
   To remove the prompt, delete this block. */
(function () {
  if (window.rivalGiftPromptLoaded) return;
  window.rivalGiftPromptLoaded = true;

  var GIFT_PROMPT_TEXT = 'Sending a gift? Choose One-Time Purchase above.';

  function syncGiftPrompt() {
    var button = document.querySelector('.givy_send_as_gift_button');
    if (!button) return;

    var note = button.parentNode.querySelector('.gift-prompt');
    if (!note) {
      note = document.createElement('p');
      note.className = 'gift-prompt';
      note.textContent = GIFT_PROMPT_TEXT;
      note.style.cssText = 'display: none; margin: 1rem 0 0; font-size: 1.4rem; line-height: 1.4;';
      button.insertAdjacentElement('afterend', note);
    }

    var form = button.form || button.closest('form');
    var plan = form ? form.querySelector('[name="selling_plan"]') : null;
    var addToCart = form ? form.querySelector('[name="add"]') : null;
    var soldOut = addToCart ? addToCart.disabled : false;
    var show = button.disabled && !soldOut && plan && plan.value;
    note.style.display = show ? 'block' : 'none';
  }

  setInterval(syncGiftPrompt, 500);
})();
